import { render, staticRenderFns } from "./CadastroFilaLaudo.vue?vue&type=template&id=1e10913b&"
import script from "./CadastroFilaLaudo.vue?vue&type=script&lang=js&"
export * from "./CadastroFilaLaudo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports